<!--
 * @Author: FengXiao
 * @Date: 2026-05-18 00:00:00
 * @LastEditors: FengXiao
 * @LastEditTime: 2026-05-18 00:00:00
-->
<!-- 活动 详情 -->
<template>
  <div class="event-detail-page page-container">
    <div class="video-player-base">
      <div class="video-bg">
        <img class="video-bg-img" :src="pageData.cover_url || pageData.cover_side_url" />
        <div class="video-bg-shadow"></div>
      </div>
      <div class="video-player-content content">
        <div class="video-player-bl">
          <div class="video-wrap event-cover-wrap">
            <img class="event-cover" :src="pageData.cover_url || pageData.cover_side_url" :alt="pageData.title" />
          </div>
        </div>
        <div class="right-area">
          <div class="speaker-info-bl">
            <div class="speaker-info-wrap">
              <div class="info-wrap">
                <div class="event-title">
                  {{ pageData.title }}
                </div>
                <div class="event-info-list">
                  <div class="event-info-item" v-if="pageData.start_time">
                    <span class="event-info-label">时间：</span>
                    <span class="event-info-value">{{ getFormattedTime() }}</span>
                  </div>
                  <div class="event-info-item" v-if="pageData.event_city">
                    <span class="event-info-label">城市：</span>
                    <span class="event-info-value">{{ pageData.event_city }}</span>
                  </div>
                  <div class="event-info-item" v-if="pageData.event_address">
                    <span class="event-info-label">地点：</span>
                    <span class="event-info-value">{{ pageData.event_address }}</span>
                  </div>
                </div>
                <div class="event-tags">
                  <span class="event-tag recommended" v-if="+pageData.recommended">推荐</span>
                  <span class="event-tag cost" v-if="+pageData.cost">付费</span>
                  <span class="event-tag free" v-else>免费</span>
                  <span class="event-tag check" v-if="+pageData.cost === 0 && +pageData.check">需审核</span>
                  <span class="event-tag status preview" v-if="+pageData.status === 1">预告</span>
                  <span class="event-tag status selling" v-if="+pageData.status === 2">售票中</span>
                  <span class="event-tag status active" v-if="+pageData.status === 3">活动中</span>
                  <span class="event-tag status ended" v-if="+pageData.status === 4">已结束</span>
                  <span class="event-tag" v-if="pageData.sale_time">开售：{{ pageData.sale_time }}</span>
                </div>
              </div>
              <div class="actions-bl">
                <button v-if="shouldShowButton(pageData)" 
                        class="action-btn" 
                        :class="{ 'disabled': !canClickButton(pageData) }"
                        :disabled="!canClickButton(pageData)"
                        @click="handleAction(pageData)">
                  {{ +pageData.cost === 0 ? '打开一席小程序报名' : '打开一席小程序购票' }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="detail-content">
      <section class="section" v-if="pageData.content">
        <div class="section-title">活动介绍</div>
        <div class="section-body" v-html="pageData.content"></div>
      </section>

      <section class="section" v-if="pageData.buying_tips">
        <div class="section-title">活动须知</div>
        <div class="section-body" v-html="pageData.buying_tips"></div>
      </section>

      <section class="section" v-if="pageData.organization">
        <div class="section-title">主办方</div>
        <div class="section-body organization-section">
          <div class="organizer-card">
            <div class="organizer-header">
              <img :src="pageData.organization.avatar_url" class="organizer-logo">
              <div class="organizer-info">
                <div class="organizer-name-row">
                  <span class="organizer-name">{{ pageData.organization.name }}</span>
                </div>
                <div class="organizer-meta-row">
                  <span class="certified-badge" v-if="pageData.organization.certify_status == 1">
                    <img src="@/assets/imgs/certified-icon.png" class="certified-icon">
                    已认证
                  </span>
                  <span class="stat-item" v-if="pageData.organization.fans_count >= 10">{{ pageData.organization.fans_count }}人关注</span>
                  <span class="stat-item slogan-text" v-else v-html="pageData.organization.quotations || ''"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="section" v-if="pageData.apply_url">
        <div class="section-title">报名链接</div>
        <div class="section-body">
          <a :href="pageData.apply_url" target="_blank" class="apply-link">{{ pageData.apply_url }}</a>
        </div>
      </section>


      <section class="section" v-if="pageData.keywords">
        <div class="section-title">关键词</div>
        <div class="section-body keywords">{{ pageData.keywords }}</div>
      </section>
    </div>
  </div>
</template>

<script>
import requestApi from '@/service';

export default {
  name: 'EventDetail',
  data() {
    return {
      pageData: {},
      is_followed: false, // 是否已关注主办方
    };
  },
  mounted() {
    this.init();
  },
  watch: {
    $route(to) {
      if (to.path === '/event/detail') {
        this.init();
      }
    },
  },
  computed: {
    peoples() {
      if (!this.pageData.peoples) return [];
      if (Array.isArray(this.pageData.peoples)) return this.pageData.peoples;
      return String(this.pageData.peoples)
        .split(/[,，\s]+/)
        .filter(Boolean);
    },
    hasPeoples() {
      return this.peoples.length > 0;
    },
  },
  methods: {
    init() {
      this.eventId = +this.$route.query.id;
      this.getData();
      this.initScrollTop();
    },
    getData() {
      const url = `/v3/api/site/event/${this.eventId}/detail/`;
      requestApi(url).then(res => {
        const eventData = res.event || res.data || res;
        this.pageData = eventData || {};
      });
    },
    handleAction(item) {
      // 只有可点击时才执行跳转
      if (this.canClickButton(item)) {
        // 隐私改版：报名/购票涉及收集用户信息，免费/付费统一引导打开一席小程序
        this.gotoLogin();
      }
    },
    shouldShowButton(data) {
      const isFree = +data.cost === 0;
      const status = +data.status;
      
      if (isFree) {
        // 免费活动：预告(1)和售票中(2)显示按钮
        return status === 1 || status === 2;
      } else {
        // 收费活动：只有售票中(2)显示按钮
        return status === 2;
      }
    },
    canClickButton(data) {
      const isFree = +data.cost === 0;
      const status = +data.status;
      
      if (isFree) {
        // 免费活动：预告(1)和售票中(2)都可点击
        return status === 1 || status === 2;
      } else {
        // 收费活动：只有售票中(2)可点击
        return status === 2;
      }
    },
    // 判断两个时间是否在同一天
    isSameDay(startTime, endTime) {
      if (!startTime || !endTime) return false;
      const start = new Date(startTime);
      const end = new Date(endTime);
      return (
        start.getFullYear() === end.getFullYear() &&
        start.getMonth() === end.getMonth() &&
        start.getDate() === end.getDate()
      );
    },
    // 格式化日期时间显示：MM-DD 周X HH:mm
    formatDateTimeDisplay(timeStr) {
      if (!timeStr) return '';
      const date = new Date(timeStr);
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const weekDays = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
      const weekDay = weekDays[date.getDay()];
      return `${month}-${day} ${weekDay} ${hours}:${minutes}`;
    },
    // 只格式化时间部分：HH:mm
    formatTimeOnly(timeStr) {
      if (!timeStr) return '';
      const date = new Date(timeStr);
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${hours}:${minutes}`;
    },
    // 获取格式化后的时间显示文本
    getFormattedTime() {
      if (!this.pageData.start_time) return '';
      
      // 如果有结束时间
      if (this.pageData.end_time) {
        if (this.isSameDay(this.pageData.start_time, this.pageData.end_time)) {
          // 同一天：05-20 周三 14:00 - 15:00
          return `${this.formatDateTimeDisplay(this.pageData.start_time)} - ${this.formatTimeOnly(this.pageData.end_time)}`;
        } else {
          // 不同天：05-20 周三 14:00 至 05-21 周四 15:00
          return `${this.formatDateTimeDisplay(this.pageData.start_time)} 至 ${this.formatDateTimeDisplay(this.pageData.end_time)}`;
        }
      }
      
      // 只有开始时间
      return this.formatDateTimeDisplay(this.pageData.start_time);
    },
    // 关注主办方
    handleFollowOrganization() {
      if (this.is_followed) {
        return;
      }
      if (!this.checkLogin('app')) { // 隐私改版：关注主办方引导下载一席App
        return;
      }
      // TODO: 调用关注接口
      console.log('关注主办方:', this.pageData.organization);
      // 这里需要添加实际的API调用
      // requestApi('/v3/api/h5/follow/', { ... }, 'post').then(...)
      this.is_followed = true;
      this.$message.success('关注成功');
    },
  },
};
</script>

<style lang="scss" scoped>
.video-player-base {
  width: 100%;
  position: relative;
  .video-bg {
    position: absolute;
    left: 0;
    top: 0;
    z-index: -1;
    width: 100%;
    height: 100%;
    max-width: 100%;
    overflow: hidden;
    &-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      vertical-align: bottom;
      opacity: 0.8;
      filter: blur(5px);
    }
    &-shadow {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 2;
      background-color: $A3;
      box-shadow: 0 0 10px 2px $C3 inset;
    }
  }
  .video-player-content {
    padding: 40px 0;
    display: flex;
    align-items: stretch;
    position: relative;
    .video-player-bl {
      width: 72%;
      max-width: 827px;
      box-sizing: border-box;
      .video-wrap {
        width: 100%;
        position: relative;
        &.event-cover-wrap {
          padding-bottom: 56.25%; // 保持16:9的宽高比
          .event-cover {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 4px;
          }
        }
      }
    }
    .right-area {
      flex: 1;
      margin-left: 30px;
      .speaker-info-bl {
        background: $C1;
        padding: 24px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        min-height: 100%;
        .speaker-info-wrap {
          display: flex;
          flex-direction: column;
          flex: 1;
          .info-wrap {
            flex: 1;
          }
          .event-title {
            font-size: 24px;
            font-family: HYXinRenWenSongW;
            font-weight: 800;
            text-align: left;
            margin-bottom: 25px;
          }
          .event-info-list {
            .event-info-item {
              width: 100%;
              color: $C13;
              font-size: 14px;
              margin-bottom: 5px;
              .event-info-label {
                width: 44px;
                display: inline-block;
              }
            }
          }
          .event-tags {
            display: flex;
            flex-wrap: wrap;
            gap: 8px;
            margin: 18px 0;
            .event-tag {
              display: inline-flex;
              align-items: center;
              justify-content: center;
              padding: 4px 12px;
              border-radius: 12px;
              font-size: 12px;
              background: rgba(0, 0, 0, 0.05);
              color: $C9;
              &.recommended {
                background: $C2;
                color: #fff;
              }
              &.cost {
                background: #f5a623;
                color: #fff;
              }
              &.free {
                background: #2ecc71;
                color: #fff;
              }
              &.check {
                background: #7b8a8f;
                color: #fff;
              }
              &.status {
                &.preview {
                  background: #7b8a8f;
                  color: #fff;
                }
                &.selling {
                  background: #ff6b35;
                  color: #fff;
                }
                &.active {
                  background: #2ecc71;
                  color: #fff;
                }
                &.ended {
                  background: $C11;
                  color: $C3;
                }
              }
            }
          }
          .actions-bl {
            position: relative;
            width: 100%;
            text-align: center;
            margin-top: 20px;
            .action-btn {
              border: none;
              outline: none;
              width: 180px;
              height: 50px;
              line-height: 50px;
              background: $C2;
              color: $C1;
              text-align: center;
              cursor: pointer;
              font-family: HYXinRenWenSongW;
              opacity: 0.9;
              text-decoration: none;
              display: inline-block;
              &:hover {
                opacity: 1;
              }
              &.disabled {
                background: $C11;
                color: $C9;
                cursor: not-allowed;
                opacity: 1;
              }
            }
          }
        }
      }
    }
  }
}
.detail-content {
  max-width: 800px;
  margin: 0 auto;
  padding: 40px 20px;
  .section {
    margin-bottom: 30px;
    .section-title {
      font-size: 24px;
      font-family: HYXinRenWenSongW;
      font-weight: 800;
      margin-top: 40px;
      margin-bottom: 25px;
      color: $C3;
    }
    .section-body {
      color: $C3;
      font-size: 16px;
      line-height: 2em;
      word-break: break-word;
      text-align: justify;
      .keywords {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
      }
      .apply-link {
        color: $C2;
        text-decoration: none;
        word-break: break-all;
        &:hover {
          text-decoration: underline;
        }
      }
    }
    .organization-section {
      padding: 0;
      .organizer-card {
        padding: 16px;
        background: #f5f7fa;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .organizer-header {
        display: flex;
        align-items: flex-start;
        flex: 1;
        min-width: 0;
      }
      .organizer-logo {
        width: 48px;
        height: 48px;
        border-radius: 4px;
        object-fit: cover;
        margin-right: 12px;
        flex-shrink: 0;
      }
      .organizer-info {
        flex: 1;
        min-width: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
      .organizer-name-row {
        margin-bottom: 4px;
      }
      .organizer-name {
        font-weight: 500;
        font-size: 17px;
        line-height: 24px;
        color: #333333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: block;
      }
      .organizer-meta-row {
        display: flex;
        align-items: center;
        margin-top: 2px;
        flex-wrap: wrap;
      }
      .certified-badge {
        display: flex;
        align-items: center;
        font-size: 11px;
        color: #1989fa;
        background: rgba(0, 119, 241, 0.11);
        padding: 1px 4px;
        border-radius: 4px;
        margin-right: 8px;
        height: 16px;
        box-sizing: border-box;
      }
      .certified-icon {
        width: 12px;
        height: 12px;
        margin-right: 2px;
      }
      .stat-item {
        font-weight: 400;
        font-size: 12px;
        line-height: 17px;
        color: #777777;
      }
      .stat-item.slogan-text {
        font-size: 11px;
        color: #999999;
        line-height: 1.2;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 100%;
      }
      .stat-item.slogan-text ::v-deep p {
        margin: 0;
        display: inline;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .stat-item.slogan-text ::v-deep strong {
        font-weight: 500;
        color: #666666;
      }
      .follow-btn {
        flex-shrink: 0;
        padding: 7px 16px;
        background: #DA3F34;
        color: #FFFFFF;
        border: none;
        border-radius: 32px;
        font-weight: 500;
        font-size: 13px;
        line-height: 18px;
        cursor: pointer;
        transition: all 0.3s ease;
        margin-left: 8px;
      }
      .follow-btn:active {
        opacity: 0.8;
        transform: scale(0.98);
      }
      .follow-btn.followed {
        background: #f5f5f5;
        color: #999999;
        cursor: not-allowed;
      }
      .follow-btn.followed:active {
        opacity: 1;
        transform: none;
      }
      .follow-btn:disabled {
        background: #f5f5f5;
        color: #999999;
        cursor: not-allowed;
        opacity: 1;
      }
      .follow-btn:disabled:active {
        opacity: 1;
        transform: none;
      }
    }
    .peoples {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
      .people-item {
        padding: 6px 12px;
        background: rgba(0, 0, 0, 0.05);
        border-radius: 12px;
        font-size: 13px;
      }
    }
  }
}
</style>
